module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 4234
// module chunks = 62